import DockingViewState from '../store/schema/DockingViewState';
import { mutatorAction } from 'satcheljs';

const updateDocking = mutatorAction(
    'updateDocking',
    (
        dockingViewState: DockingViewState,
        isBottomDocking: boolean,
        scrollLeft: number,
        scrollBarHeight: number,
        dockingWidth: number,
        bottomDockingBottom: number
    ) => {
        dockingViewState.isBottomDocking = isBottomDocking;
        dockingViewState.dockingWidth = dockingWidth;
        dockingViewState.scrollLeft = scrollLeft;
        dockingViewState.scrollBarHeight = scrollBarHeight;
        dockingViewState.bottomDockingBottom = bottomDockingBottom;
    }
);

export const updateStickyDocking = mutatorAction(
    'updateStickyDocking',
    (dockingViewState: DockingViewState, isBottomDocking: boolean) => {
        dockingViewState.isBottomDocking = isBottomDocking;
    }
);

export { updateDocking };

export default function calculateDocking(
    dockingViewState: DockingViewState,
    scrollContainerScrollTop: number,
    scrollContainerScrollLeft: number,
    scrollContainerClientHeight: number,
    scrollContainerOffsetHeight: number,
    scrollBodyOffsetTop: number,
    scrollBodyOffsetHeight: number,
    composeBodyWidth: number,
    bottomDockingHeight: number
) {
    const isBottomDocking =
        scrollBodyOffsetTop + scrollBodyOffsetHeight >=
        scrollContainerScrollTop + scrollContainerClientHeight - bottomDockingHeight;

    const bottomDockingBottom = Math.min(
        scrollContainerScrollTop +
            scrollContainerClientHeight -
            scrollBodyOffsetTop -
            bottomDockingHeight -
            dockingViewState.minBodyHeight,
        0
    );
    const scrollBarHeight = scrollContainerOffsetHeight - scrollContainerClientHeight;

    if (
        isBottomDocking != dockingViewState.isBottomDocking ||
        composeBodyWidth != dockingViewState.dockingWidth ||
        scrollContainerScrollLeft != dockingViewState.scrollLeft ||
        scrollBarHeight != dockingViewState.scrollBarHeight ||
        bottomDockingBottom != dockingViewState.bottomDockingBottom
    ) {
        updateDocking(
            dockingViewState,
            isBottomDocking,
            scrollContainerScrollLeft,
            scrollBarHeight,
            composeBodyWidth,
            bottomDockingBottom
        );
    }
}
